import React from "react";
import { logo } from "../assets";

const Logo = () => {
  return <img src={logo} width={160} height={60} className="rounded" />;
};

export default Logo;
